var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(892 2283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.193,11.607,5.95,7.364,1.707,11.607A1,1,0,1,1,.293,10.193L4.536,5.95.293,1.706A1,1,0,0,1,1.707.293L5.95,4.535,10.193.293a1,1,0,1,1,1.414,1.414L7.364,5.95l4.242,4.243a1,1,0,0,1-1.414,1.415Z",
    transform: "translate(-883 -2274)",
    fill: "#809fb8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9,12.4a1.491,1.491,0,0,1-1.06-.438L5.95,8.071l-3.889,3.89a1.5,1.5,0,0,1-2.121,0,1.5,1.5,0,0,1,0-2.122L3.829,5.95-.06,2.06a1.5,1.5,0,0,1,0-2.121,1.5,1.5,0,0,1,2.121,0L5.95,3.828,9.839-.061A1.5,1.5,0,0,1,12.4,1a1.488,1.488,0,0,1-.44,1.06L8.071,5.95,11.96,9.839A1.5,1.5,0,0,1,10.9,12.4ZM5.95,6.657l4.6,4.6a.5.5,0,0,0,.707-.708l-4.6-4.6,4.6-4.6a.5.5,0,1,0-.707-.707l-4.6,4.6-4.6-4.6a.5.5,0,1,0-.708.706l4.6,4.6-4.6,4.6a.5.5,0,0,0,.707.707Z",
    transform: "translate(-883 -2274)",
    fill: "rgba(0,0,0,0)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    transform: "translate(-892 -2283)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.4a993137ea03d2b20fb46e7309e61f74.svg";
export { ForwardRef as ReactComponent };